module.exports = __webpack_public_path__ + "img/inProcess.e8577141.png";